import React, { useRef, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactToPrint, useReactToPrint } from "react-to-print";
import NumberFormat from "react-number-format";

import { mdiPrinterSettings, mdiMicrosoftExcel } from "@mdi/js";
import Icon from "@mdi/react";
import moment from "moment";
import { Cookies } from "react-cookie";
import { Index_getConfigByKey } from "actions/DanhMuc";
import configs from "constants/configs";
import { getBranch } from "utils/utils";
import {
    getListDanhSachDonDatHang,
    updateDataSearch,
    updateListDanhSachDonDatHang,
} from "../../../../../actions/DanhSachDonDatHang";
import InDS from "Resources/ImagesNew/print-alt-5-white.png";
import LayoutNew from "common/LayoutNew";
import { Index_GetConfigAllSTKey } from "actions/DanhMuc/";
import { LamTronNghin } from "utils/utils";
import DatHangApi from "../../../../../service/DatHang/DatHangApi";
import { getUserLogin } from "../../../../../utils/utils";
import DonHangApi from "../../../../../service/DonHang/DonHangApi";
var numeral = require("numeral");
class ComponentToPrint extends React.Component {


    renderTableData() {
        if (typeof this.props.DataSend != "undefined") {
            return this.props.DataSend.map((item, i) => {
                return (

                    <tr>
                        <td class="text-center-main">{i + 1}</td>
                        <td className="text-left-main">

                            {item.OrderCode}
                        </td>
                        <td class="text-left-main">
                            {item.OrderDatHangCode}
                        </td>

                        <td class="text-center-main">
                            {moment(item.NgayTao).format("DD/MM/YYYY HH:mm:ss")}
                        </td>
                        <td class="text-right-main">
                            <NumberFormat
                                displayType={"text"}
                                value={item.TongTien}
                                thousandSeparator={true}
                            />
                        </td>
                        <td class="text-right-main">
                            <NumberFormat
                                displayType={"text"}
                                value={item.DaThanhToan}
                                thousandSeparator={true}
                            />
                        </td>
                        <td class="text-right-main">
                            <NumberFormat
                                displayType={"text"}
                                value={item.TienConlai}
                                thousandSeparator={true}
                            />
                        </td>
                        <td class="text-center-main">
                            {item.TenTrangThai}
                        </td>
                    </tr>

                );
            });
        }
    }
    render() {
        var DataSend = this.props.DataSend;
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let fromDate = params.get("fromDate");
        let toDate = params.get("toDate");
        let typeDate = params.get("typeDate");
        const HrLine = ({ color }) => (
            <hr
                style={{ color: color, backgroundColor: color, height: 1, margin: 2 }}
            />
        );
        const totalTongTien = this.props.DataSend.reduce(
            (a, v) => (a = a + LamTronNghin(v.TongTien, this.props.lamTron)),
            0
        );
        const totalDaThanhToan = this.props.DataSend.reduce(
            (a, v) => (a = a + LamTronNghin(v.DaThanhToan, this.props.lamTron)),
            0
        );
        const totalConNoLai = this.props.DataSend.reduce(
            (a, v) => (a = a + LamTronNghin(v.TienConlai, this.props.lamTron)),
            0
        );
        return (
            <div
                style={{
                    padding: "10px",
                    margin: "5px",
                    backgroundColor: "#ffffff",
                    fontSize: "14px",
                    fontFamily: "tahoma",
                    marginBottom: "50px",
                }}
                id="htmlPrint"
            >
                <div id="htmlPrintex">
                    {" "}
                    <div style={{ textAlign: "center" }}>
                        {" "}
                        <h3 style={{ marginBottom: "-2px", fontSize: "20px" }}>
                            {" "}
                            <b> DANH SÁCH ĐƠN HÀNG </b>{" "}
                        </h3>{" "}
                    </div>{" "}
                    <br />
                    <span style={{ marginBottom: "15px" }}>
                        {typeDate === "1" ? (
                            <b>Thời gian: Hôm nay</b>
                        ) : typeDate === "2" ? (
                            <b>Thời gian: Hôm qua</b>
                        ) : typeDate === "3" ? (
                            <b>Thời gian: Tuần này</b>
                        ) : typeDate === "4" ? (
                            <b>Thời gian: Tuần trước</b>
                        ) : typeDate === "5" ? (
                            <b>Thời gian: Tháng này</b>
                        ) : typeDate === "6" ? (
                            <b>Thời gian: Tháng trước</b>
                        ) : typeDate === "7" ? (
                            <b>Thời gian: Quý này</b>
                        ) : typeDate === "8" ? (
                            <b>Thời gian: Quý trước</b>
                        ) : typeDate === "9" ? (
                            <b>Thời gian: Năm này</b>
                        ) : typeDate === "10" ? (
                            <b>Thời gian: Năm trước</b>
                        ) : (
                            <>
                                <b>Thời gian: {moment(fromDate).format("DD-MM-YYYY")}</b>{" "}
                                <span style={{ marginLeft: "30px" }}>
                                    <b>Đến Ngày: {moment(toDate).format("DD-MM-YYYY")}</b>
                                </span>
                            </>
                        )}
                    </span>
                    <table
                        style={{
                            width: "100%",

                            borderCollapse: "collapsed",
                        }}
                    >
                        {" "}
                        <thead>
                            {" "}
                            <th
                                style={{
                                    width: "5%",

                                    textAlign: "center",
                                }}
                            >
                                {" "}
                                STT{" "}
                            </th>{" "}
                            <th
                                style={{

                                    textAlign: "left",
                                }}
                            >
                                {" "}
                                Mã đơn hàng{" "}
                            </th>{" "}
                            <th
                                style={{

                                    textAlign: "left",
                                }}
                            >
                                {" "}
                                Mã đơn đặt hàng{" "}
                            </th>{" "}
                            <th
                                style={{

                                    textAlign: "center",
                                }}
                            >
                                {" "}
                                Thời gian lên đơn{" "}
                            </th>{" "}
                            <th
                                style={{

                                    textAlign: "right",
                                }}
                            >
                                {" "}
                                Thành tiền đơn hàng{" "}
                            </th>{" "}
                            <th
                                style={{
                                    width: "15%",

                                    textAlign: "right",
                                }}
                            >
                                {" "}
                                Đã thanh toán{" "}
                            </th>{" "}
                            <th
                                style={{
                                    width: "15%",

                                    textAlign: "right",
                                }}
                            >
                                {" "}
                                Còn lại{" "}
                            </th>{" "}
                            <th
                                style={{
                                    width: "15%",

                                    textAlign: "center",
                                }}
                            >
                                {" "}
                                Trạng thái{" "}
                            </th>{" "}
                        </thead>{" "}
                        <tbody>{this.renderTableData()}</tbody>{" "}
                    </table>{" "}
                </div>{" "}
            </div>
        );
    }
}
export const PrintListDonHangRp = (props) => {
    const dispatch = useDispatch();
    let objBaoGia = [];
    if (typeof props.location.state != "undefined") {
        objBaoGia = props.location.state.objBaoGia;
    }

    const danhmuc = useSelector((state) => state.danhmuc);
    const { objConfigAll } = danhmuc;

    const [lamTron, setLamTron] = useState(null);
    if (objConfigAll.List.length > 0 && lamTron == null) {
        const configKhongLamTron = objConfigAll.List.find(
            (e) =>
                e.KeyID.toUpperCase() === configs.sKey.Khonglamtrontien.toUpperCase()
        );
        console.log("configKhongLamTron,", configKhongLamTron);
        setLamTron(true);
        if (
            typeof configKhongLamTron !== "undefined" &&
            configKhongLamTron != null &&
            configKhongLamTron.Value
        ) {
            if (configKhongLamTron.Value === "1") {
                setLamTron(false);
            }
        }
    }
    useEffect(() => {
        //gọi cấu hình
        dispatch(Index_GetConfigAllSTKey());
        //
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let fromDate = params.get("fromDate");
        let toDate = params.get("toDate");
        let sSearch = params.get("sSearch");
        let iTrangThaiThanhToan = params.get("iTrangThaiThanhToan");
        const dataSearch = {
            fromDate: fromDate,
            toDate: toDate,
            sSearch: sSearch,
            iTrangThaiThanhToan: iTrangThaiThanhToan,
        };
        LoadDanhSachDonDatHangAll(dataSearch);
    }, []);

    const [listDanhSachDonDatHang, setListDanhSachDonDatHang] = useState([]);
    const [TotalValue1, setTotalValue1] = useState(0);
    const [loadding, setLoadding] = useState(true);
    const [totalPage, setTotalPage] = useState(0);



    const LoadDanhSachDonDatHangAll = async (dataSearch) => {
        console.log("dataSearchdataSearchdataSearch", dataSearch)
        setLoadding(true)
        let pageIndex = 1;
        let pageSize = 1000;
        let listAll = [];
        const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
        while (true) {
            const response = await DonHangApi.InDanhSachDonHangCuaDatHang(
                dataSearch.fromDate,
                dataSearch.toDate,
                dataSearch.sSearch,
                getUserLogin().UserName,
                dataSearch.iTrangThaiThanhToan,
            );

            console.log(`Page ${pageIndex} / ${response.data.SumValue}`);

            // Gộp dữ liệu vào list chung
            listAll = [...listAll, ...response.data.List];

            // Dừng khi đã đến trang cuối
            if (pageIndex >= response.data.SumValue) break;
            pageIndex++;
            // nghỉ 0.5 giây trước khi gọi trang tiếp theo
            await sleep(500);
        }
        setLoadding(false)
        // setState nếu cần
        setListDanhSachDonDatHang(listAll);
    };


    const componentRef = useRef();
    useEffect(() => {
        const iBrank = getBranch();
        if (iBrank === "0") {
            dispatch(Index_getConfigByKey({ key: configs.sKey.THONGTIN_FORM_IN }));
        } else {
            dispatch(
                Index_getConfigByKey({
                    key: configs.sKey.THONGTIN_FORM_IN + getBranch(),
                })
            );
        }
    }, []);
    const XuatExcel = () => {
        var uri =
            "data:application/vnd.ms-excel," +
            encodeURIComponent(document.getElementById("htmlPrintex").outerHTML);
        var downloadLink = document.createElement("a");
        downloadLink.href = uri;
        downloadLink.download =
            "DanhSachDonDatHangConNo" + moment().format("YYYYMMDDHHmm") + ".xls";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };
    const handlePrint = useReactToPrint({ content: () => componentRef.current });
    return (
        <LayoutNew isPrint={true} isProgress={loadding}>
            {" "}
            <ComponentToPrint
                ref={componentRef}
                DataSend={listDanhSachDonDatHang}
                ThongTinIn={danhmuc.objConfig}
                lamTron={lamTron}
            />{" "}
            <div
                class="fixed"
                style={{ width: "100%", left: "0px", paddingRight: "30px" }}
            >
                {" "}
                <div style={{ width: "100%", clear: "both" }}>
                    {" "}
                    <div style={{ marginTop: "25px", float: "right", display: "flex" }}>
                        {" "}
                        <a
                            class="button-Add-NoIcon bg-blue-main"
                            href=""
                            onClick={XuatExcel}
                        >
                            {" "}
                            <Icon
                                path={mdiMicrosoftExcel}
                                title="In"
                                size={1.4}
                                color="white"
                            />{" "}
                            &nbsp; Xuất excel{" "}
                        </a>{" "}
                        &nbsp;&nbsp;&nbsp;&nbsp;{" "}
                        <button class="button-Icon-text bg-blue-main" onClick={handlePrint}>
                            {" "}
                            <img src={InDS} title="In" alt="" /> In danh sách{" "}
                        </button>{" "}
                    </div>{" "}
                </div>{" "}
            </div>{" "}
        </LayoutNew>
    );
};
